import { render, staticRenderFns } from "./turiinBusBaiguullaga.vue?vue&type=template&id=9c5eb5d6&"
import script from "./turiinBusBaiguullaga.vue?vue&type=script&lang=js&"
export * from "./turiinBusBaiguullaga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports